import styled from 'styled-components';

export const ImgDiv = styled.div`
  display: flex;
  justify-content: ${({ $justify }) => $justify || "center"};
  margin: 1.5rem;
`;

export const HomeImg = styled.img`
  width: 80%;
  max-width: 750px;
`;

export const HeaderText = styled.h1`
  font-size: 2.5rem;
  color: red;
  text-align: center;
`;
